import { Tag } from "antd";

export const formatDate = (val) => (val ? new Date(val).toLocaleDateString() : "-");

export const formatPercentage = (val) => {
  const num = Number(val || 0);
  return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
};

export const StatusTag = (status) => {
  const statusClassMap = {
    Completed: "status-tag--completed",
    "In Progress": "status-tag--in-progress",
  };
  const statusClass = statusClassMap[status] || "status-tag--not-started";
  return <Tag className={`status-tag ${statusClass}`}>{status}</Tag>;
};

export const calculateUserProgress = (enrollments) => {
  const courseMap = new Map();
  enrollments.forEach((e) => {
    if (!courseMap.has(e.courseTitle)) {
      courseMap.set(e.courseTitle, e.courseCompletionPercentage || 0);
    }
  });
  const values = Array.from(courseMap.values());
  const avg = values.reduce((a, b) => a + b, 0) / values.length;
  return values.length ? (avg % 1 === 0 ? avg : Number(avg.toFixed(2))) : 0;
};

export const calculateGroupProgress = (enrollments) => {
  const userCourseMap = new Map();
  enrollments.forEach((e) => {
    const key = `${e.userId}-${e.courseTitle}`;
    if (!userCourseMap.has(key)) {
      userCourseMap.set(key, e.courseCompletionPercentage || 0);
    }
  });
  const values = Array.from(userCourseMap.values());
  const avg = values.reduce((a, b) => a + b, 0) / values.length;
  return values.length ? (avg % 1 === 0 ? avg : Number(avg.toFixed(2))) : 0;
};

export const calculateWorstAdherence = (users, ADHERENCE_ORDER) => {
  if (!users || users.length === 0) return "Completed";
  return users.reduce((worst, user) => {
    const currentIndex = ADHERENCE_ORDER.indexOf(user.adherence || "Completed");
    const worstIndex = ADHERENCE_ORDER.indexOf(worst || "Completed");
    return currentIndex > worstIndex ? user.adherence : worst;
  }, "Completed");
};

export const calculateGroupStatus = (users) => {
  if (!users || users.length === 0) return "Not Started";
  const statuses = users.map((u) => u.status);
  const completedCount = statuses.filter((s) => s === "Completed").length;
  const inProgressCount = statuses.filter((s) => s === "In Progress").length;
  if (completedCount === statuses.length) return "Completed";
  if (inProgressCount > 0) return "In Progress";
  return "Not Started";
};

export const getEnrollmentType = (enrollmentSource) => {
  switch (enrollmentSource) {
    case "BUNDLE":
    case "INDIVIDUAL":
      return "User";
    case "GROUP_BUNDLE":
    case "GROUP":
      return "Group";
    default:
      return "User";
  }
};

export const debounce = (fn, delay = 500) => {
  let timerId;

  const debouncedFn = (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      fn(...args);
    }, delay);
  };

  return debouncedFn;
};